import React, {useState} from 'react';
import styled from 'styled-components';
import {useBoundStore} from "../../stores/useBoundStore";
import ShapeButtons from "../atoms/ShapeButtons";
import ColorButtons from "../atoms/ColorButtons";
import RotationButtons from "../atoms/RotationButtons";
import InteractiveControl from "./InteractiveControl";

const Holder = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2rem;
  align-items: start;
  border-radius: 1rem;
  margin: 0 0 2rem 0;
  @media( ${props => props.theme.breakpoints.md} ) {
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 2rem;
  }

  p {
    margin: 0 0 0.5rem 0;
    text-align: center;
    ${(props) => props.theme.fluidType(-1)};
  }

  .coming-soon {
    display: grid;
    border: 1px dotted;
    text-align: center;
    align-items: center;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
    p {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      ${(props) => props.theme.fluidType(-2)};
    }
  }

  .stroke {
    display: none;
    @media ( ${props => props.theme.breakpoints.md} ) {
      display: block;
    }
  }
`;

const QuadPicker = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;

  .inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function ControlUI() {
  const [activeQuad, setActiveQuad] = useState(0);

  const settings = [
    useBoundStore((state) => state.quad1),
    useBoundStore((state) => state.quad2),
    useBoundStore((state) => state.quad3),
    useBoundStore((state) => state.quad4),
  ]

  const settingsHandlers = [
    useBoundStore((state) => state.setQuad1Val),
    useBoundStore((state) => state.setQuad2Val),
    useBoundStore((state) => state.setQuad3Val),
    useBoundStore((state) => state.setQuad4Val),
  ]

  return (
    <Holder>
      <div>
        <p>Quadrant</p>
        <QuadPicker>
          <div className="inner">
            <InteractiveControl clickHandler={(i) => setActiveQuad(i)} activeQuad={activeQuad} />
          </div>
        </QuadPicker>
      </div>
      <div>
        <p>Shape</p>
        <ShapeButtons clickHandler={settingsHandlers[activeQuad]} />
      </div>
      <div>
        <p>Colour</p>
        <ColorButtons clickHandler={settingsHandlers[activeQuad]} />
      </div>
      <div>
        <p>Rotation</p>
        <RotationButtons clickHandler={settingsHandlers[activeQuad]} settings={settings[activeQuad]} />
      </div>
      <div className="stroke">
        <p>Stroke</p>
        <div className="coming-soon"><p>Coming Soon</p></div>
      </div>

    </Holder>
  )
}

export default ControlUI;